import React, { FC, CSSProperties, useRef, memo } from 'react';
import { Icon } from '@surveycake/rc';
import { useHoverOnRef } from '@surveycake/rhooks';
import { heartOutlined } from '@surveycake/rc';
import { heartFilled } from '@surveycake/rc';
import { starOutlined } from '@surveycake/rc';
import { starFilled } from '@surveycake/rc';
import { thumbUpOutlined } from '@surveycake/rc';
import { thumbUpFilled } from '@surveycake/rc';
import { tickOutlined } from '@surveycake/rc';
import { tickFilled } from '@surveycake/rc';
import { useRatingIconStyles } from './styles';

const iconsMap = {
  HEART: [heartFilled, heartOutlined],
  STAR: [starFilled, starOutlined],
  THUMB: [thumbUpFilled, thumbUpOutlined],
  TICK: [tickFilled, tickOutlined]
};

export interface RatingIconProps {
  level: number;
  shape: string;
  setValue: (level: number) => void;
  filled?: boolean;
  active?: boolean;
  last?: boolean;
  style?: CSSProperties;
}

const RatingIcon: FC<RatingIconProps> = ({
  level,
  shape,
  setValue,
  filled,
  active,
  last,
  style
}) => {
  const icons = (iconsMap as any)[shape];
  const iconRef = useRef<SVGSVGElement>(null);
  const hover = useHoverOnRef(iconRef);
  const styles = useRatingIconStyles([active, last]);

  return (
    <Icon
      ref={iconRef}
      className={styles.ratingIcon}
      icon={filled || hover ? icons[0] : icons[1]}
      onClick={() => setValue(level)}
      style={style}
    />
  );
};

RatingIcon.defaultProps = {
  filled: false,
  active: false,
  last: false
};

export default memo(RatingIcon);
